// A rewrite of ifvisible.js to remove cruft and fix minor issues.
// https://github.com/serkanyersen/ifvisible.js/blob/master/src/ifvisible.js

// Most of the functionality is in IdleEngine. This file just plugs the engine
// into various browser globals that are hard to mock in tests.
const IdleEngine = require("./IdleEngine");

// The IdleEngine instance. Created by the start function.
let eng = null;

// Initialization helper. Inspects browser to determine document hidden
// attribute and visibility change event and adds appropriate listener.
// Returns whether we are initially hidden.
const setupVisibilityEvent = function() {
	let hiddenAttr;
	let visibilityEvent;
	if (typeof document.hidden !== "undefined") {
		hiddenAttr = "hidden";
		visibilityEvent = "visibilitychange";
	} else if (typeof document.mozHidden !== "undefined") {
		hiddenAttr = "mozHidden";
		visibilityEvent = "mozvisibilitychange";
	} else if (typeof document.msHidden !== "undefined") {
		hiddenAttr = "msHidden";
		visibilityEvent = "msvisibilitychange";
	} else if (typeof document.webkitHidden !== "undefined") {
		hiddenAttr = "webkitHidden";
		visibilityEvent = "webkitvisibilitychange";
	}
	if (!hiddenAttr) {
		window.addEventListener("blur", () => eng.triggerBlur());
		window.addEventListener("focus", () => eng.triggerFocus());
		return false;
	} else {
		document.addEventListener(visibilityEvent, () => {
			document[hiddenAttr] ? eng.triggerBlur() : eng.triggerFocus();
		});
		return !!document[hiddenAttr];
	}
};

// Initialization helper. Listens for things that end idle periods.
const trackIdle = function() {
	const handleInput = () => eng.handleInput();
	document.addEventListener("mousemove", handleInput);
	document.addEventListener("mouseup", handleInput);
	document.addEventListener("keyup", handleInput);
	document.addEventListener("touchstart", handleInput);
	window.addEventListener("scroll", handleInput);
	eng.listenToFocus(handleInput);
};

// Public interface.

// Call this before using any of the functions below.
const start = function(idleDuration) {
	if (eng) {
		return;
	}
	let currentIdleTimeout = null;
	eng = new IdleEngine({
		idleDuration,
		getNow: () => Date.now(),
		resetTimeout: (f, time) => {
			clearTimeout(currentIdleTimeout);
			currentIdleTimeout = setTimeout(f, time);
		},
	});

	if (!global.document || !global.window) {
		throw new Error("Cannot use IdleInput without global window and document.");
	}
	const isHidden = setupVisibilityEvent();
	if (isHidden) {
		eng.triggerBlur();
	} else {
		eng.handleInput();
	}
	trackIdle();
};

// See IdleEngine for more info about these.

const getIdleDuration = () => eng.getIdleDuration();
const setIdleDuration = x => eng.setIdleDuration(x);
const getActiveBetween = (t1, t2) => eng.getActiveBetween(t1, t2);
const resetIdleTimeout = () => eng.handleInput();
const listenToBlur = cb => eng.listenToBlur(cb);
const listenToFocus = cb => eng.listenToFocus(cb);
const listenToIdle = cb => eng.listenToIdle(cb);
const listenToWake = cb => eng.listenToWake(cb);
const listenToSleep = cb => eng.listenToSleep(cb);
const listenToStatus = cb => eng.listenToStatus(cb);

module.exports = {
	start,
	getIdleDuration,
	setIdleDuration,
	resetIdleTimeout,
	getActiveBetween,
	listenToBlur,
	listenToFocus,
	listenToIdle,
	listenToWake,
	listenToStatus,
	listenToSleep,
};
